import React from "react";
import BootstrapTable from "@partseye/react-bootstrap-table-next";
import "@partseye/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "@partseye/react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import { getDateFormatDealer } from "../GetDateFormatDealer";

function SuggestionOrderReturnHistory (props) {
    const dateFormat = getDateFormatDealer(props.dateFormat);
    const tableColumns = [
        {"dataField": "reference",
            "text": props.pageText.reference,
            "formatter": (val) => (val ? val : props.pageText.na) },
        {"dataField": "date",
            "text": props.pageText.date,
            "formatter": (val, row) => props.dealerTimeZoneConvertor(row.orderDate, dateFormat),
        },
        {"dataField": "partNumber",
            "text": props.pageText.partNumber},
        {"dataField": "suggestedQuantity",
            "text": props.pageText.quantitySuggested},
        {"dataField": "orderQuantity",
            "text": props.pageText.actualQuantity},
        {"dataField": "type",
            "text": props.pageText.type,
            "formatter": (val) => (val ? val : props.pageText.na) }
    ];

    props.partInfo.forEach((p) => p.key = p.reference + p.partNumber + p.orderQuantity);

    return (
        <div className="basic-info container-fluid">
            <h5 className="basic-info-title title">
                {props.pageText.suggestionTitle}
                <i
                    className="material-icons"
                    title={props.pageText.suggestionToolTip}
                >
                    help
                </i>
            </h5>
            <div className={props.partInfo.length > 5 ? "basic-info-content-with-scrolled fixed-height" : "basic-info-content"}>
                <BootstrapTable
                    bootstrap4
                    columns={tableColumns}
                    condensed
                    data={props.partInfo}
                    headerClasses="thead-light"
                    id="suggestionOrderReturnHistory"
                    keyField="key"
                    striped
                />
            </div>
        </div>
    );

}

export default SuggestionOrderReturnHistory;
